import QuotationService from "services/QuotationService";
import OrderService from "services/OrderService";

class ExportService {

  static GetDataToExport = async (token, startDate, endDate, tennantId, supplierId, type) => {
    if (String(type).toLowerCase() === 'oferta') {
      return await QuotationService.getQuotationsToExport(token, startDate, endDate, tennantId, supplierId);

    } else if (String(type).toLowerCase() === 'pedido') {
      return await OrderService.getOrdersToExport(token, startDate, endDate, tennantId, supplierId);

    }

    return [];
  }

  static FlattenObject = (obj, prefix = '') => {
    let result = [{}];

    Object.entries(obj).forEach(([key, value]) => {
      const newKey = prefix
        ? `${prefix}.${key}`
        : key;

      // Objeto
      if (
        value !== null &&
        typeof value === 'object' &&
        !Array.isArray(value)
      ) {
        const nested = ExportService.FlattenObject(value, newKey);

        result = result.flatMap(row =>
          nested.map(nestedRow => ({
            ...row,
            ...nestedRow
          }))
        );

        return;
      }

      // Array
      if (Array.isArray(value)) {

        // Array vazio
        if (value.length === 0) {
          result = result.map(row => ({
            ...row,
            [newKey]: ''
          }));

          return;
        }

        // Array de objetos
        if (
          typeof value[0] === 'object' &&
          value[0] !== null
        ) {
          const arrayRows = value.flatMap(item =>
            ExportService.FlattenObject(item, newKey)
          );

          result = result.flatMap(row =>
            arrayRows.map(arrayRow => ({
              ...row,
              ...arrayRow
            }))
          );

          return;
        }

        // Array de valores simples
        result = result.map(row => ({
          ...row,
          [newKey]: value.join(', ')
        }));

        return;
      }

      // Valor simples
      result = result.map(row => ({
        ...row,
        [newKey]: value
      }));
    });

    return result;
  };

  static JsonToCSV = (data) => {
    if (!data || data.length === 0) {
      return '';
    }

    const flattenedData = data.flatMap(row =>
      ExportService.FlattenObject(row)
    );

    const headers = [
      ...new Set(
        flattenedData.flatMap(row => Object.keys(row))
      )
    ];

    const rows = flattenedData.map(row =>
      headers.map(header => {
        const value = row[header];

        if (value === null || value === undefined) {
          return '""';
        }

        return `"${String(value).replace(/"/g, '""')}"`;
      }).join(';')
    );

    return [
      headers.join(';'),
      ...rows
    ].join('\r\n');
  };

  static Export = async (token, { startDate, endDate, type, tennant, supplier }) => {
    const response = await ExportService.GetDataToExport(token, startDate, endDate, (tennant?.Id || null), (supplier?.Id || null), type);

    const csv = ExportService.JsonToCSV(response);

    const blob = new Blob(
      ["\ufeff" + csv],
      { type: "text/csv;charset=utf-8;" }
    );

    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;

    let archiveMiddleName = 'Todos';
    
    archiveMiddleName = tennant && supplier ? `${tennant.CompanyName}_e_${supplier.CompanyName}` :
      tennant ? tennant.CompanyName :
        supplier ? supplier.CompanyName : archiveMiddleName;

    a.download = `${type}s_${archiveMiddleName}_${startDate}_a_${endDate}.csv`;

    document.body.appendChild(a);
    a.click();
    a.remove();

    window.URL.revokeObjectURL(url);
  };

}

export default ExportService;